import { COLORS } from '@constants/colors';

export const useStyles = () => ({
  paper: {
    borderRadius: 3,
    background: '#0f141c',
    color: '#fff',
    position: 'relative',
  },
  title: {
    fontWeight: 600,
    color: '#fff',
    paddingRight: '48px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingTop: '4px',
  },
  dropZone: {
    border: '1px dashed #2d384a',
    borderRadius: 2,
    padding: 3,
    textAlign: 'center' as const,
    background: '#0f141c',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  dropZoneActive: {
    borderColor: COLORS.MYTAVERSE_BLUE,
    background: '#142033',
  },
  dropZoneTitle: {
    color: '#fff',
    marginTop: 1,
  },
  dropZoneSubtitle: {
    color: '#aeb7c7',
    marginTop: 0.5,
    marginBottom: 1,
  },
  selectButton: {
    marginTop: 1.5,
    textTransform: 'none' as const,
  },
  uploadIcon: {
    fontSize: 40,
    color: COLORS.MYTAVERSE_BLUE,
  },
  previewImage: {
    width: '100%',
    maxHeight: 240,
    objectFit: 'contain' as const,
    borderRadius: 8,
    background: '#0e121a',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    marginTop: 1,
  },
  statusText: {
    color: '#d9e1f1',
  },
  previewRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    marginTop: 1,
    padding: 1.5,
    borderRadius: 1,
    background: '#141a24',
    border: '1px solid #1f2a3a',
  },
  previewText: {
    color: '#9fb4d1',
    wordBreak: 'break-all' as const,
    fontSize: 13,
  },
  errorText: {
    marginTop: 1,
    color: COLORS.RED,
  },
  actions: {
    padding: '0 24px 16px',
  },
  closeButton: {
    position: 'absolute' as const,
    top: 8,
    right: 8,
    color: '#fff',
  },
  confirmButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    minWidth: 140,
  },
});

